// removed by extract-text-webpack-plugin
module.exports = {"block":"ErrorScreen__block-3nhfR"};